module.exports = __webpack_public_path__ + "media/discovery-ui/assets/social/youtube-white-2a83879be88936001c686ef51b406771.svg";